 import React ,{ReactNode,FC}from 'react'

interface CardContentProps {
    children: ReactNode
}

export const CardContent:FC<CardContentProps> = ({children}) => {
  return (
      <h2 className='m-0' style={{fontSize:22,color:'#1D2939'}}>{children}</h2>
  )
}
